var _path, _path2, _path3;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFlag = function SvgFlag(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 78,
    fill: "none",
    viewBox: "0 0 67 78",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#183E62",
    d: "M.978 78C.438 78 0 77.484 0 76.848V1.152C0 .516.438 0 .978 0s.979.516.979 1.152v75.696c0 .636-.438 1.152-.979 1.152"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#183E62",
    d: "M45.84 53.935c-4.749 0-9.205-.602-11.818-2.425-2.776-1.936-9.31-2.535-18.895-1.73-7.356.617-13.926 1.864-13.992 1.876a.88.88 0 0 1-.79-.26A1.25 1.25 0 0 1 0 50.52V7.734c0-.567.351-1.05.827-1.138C1.912 6.396 27.473 1.77 35 6.73c7.018 4.626 29.868-.08 30.098-.129a.88.88 0 0 1 .8.251c.221.22.35.542.35.883V50.52c0 .555-.337 1.032-.801 1.133-.635.138-10.642 2.283-19.605 2.283m-23.344-6.798c5.178 0 9.946.593 12.523 2.39 2.816 1.965 8.882 2.572 17.54 1.757 5.205-.49 9.909-1.37 11.73-1.733V9.096c-4.876.928-23.501 4.089-30.246-.357-2.824-1.861-9.38-2.437-18.957-1.665-5.82.469-11.14 1.316-13.13 1.654v40.447c3.196-.561 12.376-2.038 20.54-2.038"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#183E62",
    d: "M7.927 16.83c-.58 0-.937-.493-.992-1.006-.059-.54.223-1.176.86-1.293a1 1 0 0 1 .18-.013l.49-.056c12.447-1.433 19.964-1.365 22.34.202.473.31.64 1.013.377 1.568-.264.555-.86.753-1.332.442-.916-.604-4.815-1.804-21.195.08l-.49.056-.142.015a1 1 0 0 1-.096.004"
  })));
};
export default SvgFlag;